/* @flow */
/* eslint no-unused-vars: 0 */

import React from "react"

class AdminSearchProductPagination extends React.PureComponent {
  constructor(props) {
    super(props);

    this.calculateFirstProduct = this.calculateFirstProduct.bind(this);
    this.calculateLastProduct = this.calculateLastProduct.bind(this);

    this.state = {
      number_of_pages: 0,
      first_product: 0,
      last_product: this.props.products_total,
      pagination_links_to_show: 5,
      first_page: props.current_page + 5,
      last_page: props.current_page + 5
    };
  }

  componentWillReceiveProps(nextProps) {
    let first_page = nextProps.current_page;
    let last_page = first_page + this.state.pagination_links_to_show;
    this.setState({
      first_product: this.calculateFirstProduct(nextProps),
      last_product: this.calculateLastProduct(nextProps),
      number_of_pages: this.calculateNumberOfPages(nextProps),
      first_page,
      last_page
    });
  }

  calculateFirstProduct(props) {
    return (props.current_page - 1) * props.per_page + 1;
  }

  calculateLastProduct(props) {
    if (props.per_page > props.products_total) {
      return props.products_total;
    } else {
      var total = this.calculateFirstProduct(props) + this.props.per_page - 1;
      if (total < props.products_total) {
        return total;
      } else {
        return props.products_total;
      }
    }
  }

  calculateNumberOfPages(props) {
    return Math.ceil(props.products_total / this.props.per_page);
  }

  render() {
    let paginationLinks = [];
    let display_first_link = true;
    let display_last_link = true;

    if (this.props.products_total >= 1) {
      paginationLinks = [
        ...Array(this.state.pagination_links_to_show)
      ].map((x, page) => {
        page += this.props.current_page - 2;
        if (page >= 1) {
          if (
            page <= this.state.number_of_pages ||
            page <=
              this.state.number_of_pages - this.state.pagination_links_to_show
          ) {
            if (page === 1) {
              display_first_link = false;
            }
            if (page === this.state.number_of_pages) {
              display_last_link = false;
            }
            if (page >= 1) {
              return (
                <a
                  className={
                    "pagination--link " +
                    (this.props.current_page == page ? "selected" : "")
                  }
                  href="#"
                  key={page}
                  onClick={e => {
                    e.preventDefault();
                    this.props.setPage(page, true);
                  }}
                >
                  {page}
                </a>
              );
            }
          }
        }
      });
    }

    const first_link =
      this.props.current_page !== 1 && display_first_link ? (
        <a
          className="pagination--link"
          href="#"
          key={"first-link"}
          onClick={e => {
            e.preventDefault();
            this.props.setPage(1, true);
          }}
        >
          1 ..
        </a>
      ) : (
        ""
      );

    const last_link =
      this.props.current_page !== this.state.number_of_pages &&
      display_last_link ? (
        <a
          className="pagination--link"
          href="#"
          key={"last-link"}
          onClick={e => {
            e.preventDefault();
            this.props.setPage(this.state.number_of_pages, true);
          }}
        >
          .. {this.state.number_of_pages}
        </a>
      ) : (
        ""
      );
    const default_page = this.props.current_page;

    return (
      <div className="row-fluid pagination--details">
        <div className="pagination--links span4">
          <a
            className="pagination--link"
            href="#"
            key={"previous-link"}
            onClick={e => {
              e.preventDefault();
              if (this.props.current_page > 1) {
                this.props.setPage(this.props.current_page - 1, true);
              }
            }}
          >
            &lsaquo;&lsaquo;
          </a>

          {first_link}

          {paginationLinks}

          {last_link}

          <a
            className="pagination--link"
            href="#"
            key={"next-link"}
            onClick={e => {
              e.preventDefault();
              if (this.props.current_page !== this.state.number_of_pages) {
                this.props.setPage(this.props.current_page + 1, true);
              }
            }}
          >
            &rsaquo;&rsaquo;
          </a>
        </div>
        <div className="pagination--summary span4">
          Displaying{" "}
          {this.props.mode === "Product"
            ? "Product(s)"
            : "Product Categories"}{" "}
          <b>
            {this.state.first_product} - {this.state.last_product}
          </b>{" "}
          of <b>{this.props.products_total}</b>
        </div>

        <div className="pagination--summary span4">
          <button
            className="pull-right"
            onClick={() => {
              this.props.displaySaveModal(true);
            }}
          >
            Update / Process
          </button>
        </div>
      </div>
    );
  }
}

export default AdminSearchProductPagination;
